import BaseService from "@/app/core/base/BaseService";
import { toast } from "react-toastify";
import { HandleErrors } from "../../util/helpers/ErrorHelper";

export const CorreiosController = {
    BaseQuotation: {
        "idLote": "bd36c7d1-37d8-48c0-bdfe-112b08403c53",
        parametrosProduto: {
            coProduto: "03140",
            nuRequisicao: "3e8a5b5c",
            nuContrato: null,
            nuDR: null,
            cepOrigem: "06124190",
            psObjeto: "100",
            nuUnidade: null,
            tpObjeto: "2",
            comprimento: "50",
            largura: "100",
            altura: "50",
            diametro: null,
            psCubico: null,
            servicosAdicionais: null,
            criterios: null,
            dtEvento: null,
            coUnidadeOrigem: null,
            dtArmazenagem: null,
            cepDestino: "06132330",
            sgPaisDestino: null
        }
    },

    BaseServices: {
        "codigo": "03140",
        "descricao": "SEDEX 12 CONTRATO AG",
        "coSegmento": "3",
        "descSegmento": "ENCOMENDA"
    },

    Quotation: async function (data, response, error) {
        await BaseService(
            {
                method: "POST",
                url: `correios/preco`,
                data: data,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    Servicos: async function (response, error) {
        await BaseService(
            {
                method: "GET",
                url: `correios/servicos`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    DeclaracaoConteudo: async function (response, error) {
        await BaseService(
            {
                method: "GET",
                url: `correios/DeclaracaoConteudo`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    AvisoRecebimento: async function (response, error) {
        await BaseService(
            {
                method: "GET",
                url: `correios/AvisoRecebimento`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    PrePostagens: async function (response, error) {
        await BaseService(
            {
                method: "GET",
                url: `correios/PrePostagens`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    Objetos: async function (response, error) {
        await BaseService(
            {
                method: "GET",
                url: `correios/rastro/Objetos`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    RastroObjetos: async function (codigoObjeto, response, error) {
        await BaseService(
            {
                method: "GET",
                url: `correios/rastro/Objetos/${codigoObjeto}`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    RotuloSolicitados: async function (response, error) {
        await BaseService(
            {
                method: "GET",
                url: `correios/rotulo/solicitadas`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    CreateRotulo: async function (idPrePostagem, response, error) {
        await BaseService(
            {
                method: "POST",
                url: `correios/rotulo/lote/assincrono/pdf`,
                data: {
                    tipoRotulo: "P",
                    formatoRotulo: "ET",
                    idsLotePrePostagem: [
                        {
                            idPrePostagem: idPrePostagem
                        }
                    ]
                }
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    RequestRotulo: async function (idRecibo, response, error) {
        await BaseService(
            {
                method: "POST",
                url: `correios/rotulo/download/assincrono/${idRecibo}`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    Saldo: async function (response, error) {
        await BaseService(
            {
                method: "GET",
                url: `correios/rotulo/saldo`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },


}